import { Alert, Checkbox, Typography } from "antd";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";

const DependabotSyncPRsConfig = forwardRef(function DependabotSyncPRsConfig(
  props,
  ref
) {
  const [dependabotSyncPrs, setDependabotSyncPrs] = useState();
  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.syncDependabotPRs();
    promise.then(setDependabotSyncPrs);
    return cancel;
  }, []);

  const handleDependabotSyncPrChange = useCallback((e) => {
    setDependabotSyncPrs(e.target.checked);
  }, []);

  const onSave = useCallback(() => {
    return ToolsIntegrationsAPI.updateDependabotSyncPRs(dependabotSyncPrs)
      .promise;
  }, [dependabotSyncPrs]);

  useImperativeHandle(ref, () => ({ onSave }));

  return (
    <Alert
      className="p-sm"
      message={
        <Typography.Text strong>
          Configure ingestion of ArmorCode Findings
        </Typography.Text>
      }
      description={
        <>
          <Checkbox
            checked={dependabotSyncPrs}
            onChange={handleDependabotSyncPrChange}
            className="m-r-xs"
          />
          <Typography.Text>Ingest Dependabot Pull Requests</Typography.Text>
        </>
      }
    />
  );
});

export default DependabotSyncPRsConfig;
